import React, { FunctionComponent } from "react";

interface OwnProps {
    color?: string;
    opacity?: number;
}

type Props = OwnProps;

const UsersSvg: FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = (props) => {
    return (
        <svg
            width="17px"
            height="15px"
            viewBox="0 0 17 15"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                id="Admin"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity={props.opacity ?? 0.5}
            >
                <g
                    id="Admin---Organization---Users"
                    transform="translate(-35.000000, -409.000000)"
                    fill={props.color ?? "#1F1F1F"}
                    fillRule="nonzero"
                >
                    <g id="Left-Nav" transform="translate(0.000000, 64.000000)">
                        <g
                            id="Group-10"
                            transform="translate(24.000000, 104.000000)"
                        >
                            <g
                                id="Group-9"
                                transform="translate(0.000000, 232.000000)"
                            >
                                <g
                                    id="Icon/Building"
                                    transform="translate(11.000000, 9.000000)"
                                >
                                    <path
                                        d="M12.0939325,0.4959375 C13.7454696,0.590149716 15.0289633,1.96986138 15.00375,3.62389125 L15.00375,3.62389125 L15.00375,4.99875 C15.0027515,6.172765 14.3174416,7.23845509 13.2496544,7.72645375 L13.2496544,7.72645375 L13.3837381,8.40187563 C13.4567041,8.76991601 13.7294321,9.06620837 14.0901794,9.169355 L14.0901794,9.169355 L16.2795469,9.79474563 C16.7088193,9.91752952 17.0048017,10.3098592 17.005,10.7563463 L17.005,10.7563463 L17.005,14.004375 C17.005,14.28069 16.7810025,14.5046875 16.5046875,14.5046875 L16.5046875,14.5046875 L11.9098175,14.5046875 C11.9690734,14.3444589 12.0002168,14.1752015 12.001875,14.004375 L12.001875,14.004375 L12.001875,11.7569713 C11.9995795,10.864413 11.4084687,10.0804777 10.5509687,9.83276938 L10.5509687,9.83276938 L9.07004375,9.409505 L9.91357062,9.16835438 C10.2743178,9.06520775 10.5470459,8.76891538 10.6200119,8.400875 L10.6200119,8.400875 L10.7540956,7.72645375 C10.4131222,7.56812592 10.1049227,7.3471591 9.84552812,7.07504688 C9.94663686,6.72536884 9.99883162,6.36337293 10.000625,5.999375 L10.000625,5.999375 L10.000625,4.62451625 C9.99954416,3.78161451 9.7435122,2.9587543 9.26616625,2.26404188 C9.76454304,1.15712317 10.8805455,0.459325454 12.0939325,0.4959375 Z M6.0901825,1.4965625 C7.74171954,1.59077472 9.02521331,2.97048638 8.99999984,4.62451625 L8.99999984,4.62451625 L8.99999984,5.999375 C8.99861038,7.17302761 8.31336253,8.23823034 7.24590438,8.72607812 L7.24590438,8.72607812 L7.37998813,9.4015 C7.45261649,9.76992362 7.7254062,10.0666694 8.08642938,10.16998 L8.08642938,10.16998 L10.2757969,10.7953706 C10.7050693,10.9181545 11.0010516,11.3104842 11.0012498,11.7569712 L11.0012498,11.7569712 L11.0012498,14.004375 C11.0012498,14.28069 10.7772525,14.5046875 10.5009373,14.5046875 L10.5009373,14.5046875 L1.49531234,14.5046875 C1.21899754,14.5046875 0.994999688,14.28069 0.994999688,14.004375 L0.994999688,14.004375 L0.994999688,11.7569712 C0.994751668,11.3101133 1.29082404,10.9172559 1.72045313,10.79437 L1.72045313,10.79437 L3.90982063,10.1689794 C4.27056782,10.0658327 4.54329587,9.76954038 4.61626188,9.4015 L4.61626188,9.4015 L4.75034563,8.72707875 C3.68255842,8.23908009 2.99724853,7.17339 2.99624984,5.999375 L2.99624984,5.999375 L2.99624984,4.4984375 C2.99586792,3.68608104 3.32474143,2.9082529 3.90777258,2.34256938 C4.49080371,1.77688586 5.27820803,1.47165014 6.0901825,1.4965625 Z"
                                        id="Combined-Shape"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default UsersSvg;
